import '@/assets/_variables_clients.css';

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import moment from 'moment';
import Vue from 'vue';
import Notifications from 'vue-notification';
import VueTheMask from 'vue-the-mask';
import App from './App.vue';
import EmailInput from './components/EmailInput.vue';
import router from './router';
import store from './store';
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.filter('CPF', function (documentId, documentType) {
  if (!documentId) return '000.000.000-00';
  documentId = typeof documentId != 'string' ? documentId.toString() : documentId;
  if (documentType == 'J') {
    documentId = documentId.padStart(14, '0');
    documentId = documentId.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    documentId = documentId.padStart(11, '0');
    documentId = documentId.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  return documentId;
});

Vue.filter('firstName', function (name) {
  return name.split(' ')[0];
});

Vue.filter('camelCase', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('PHONE', function (value) {
  if (!value) return '';
  value = value.replace(/[^0-9]/g, '');
  if (value.startsWith('+55') || value.startsWith('55')) {
    value = value.slice(2);
  }
  return `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
});

Vue.filter('PRICE', function (value) {
  if (value == null || Number.isNaN(Number(value))) return '--';
  const reais = Number(value) / 100;
  return reais.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
});

Vue.filter('SERVICE_TYPE', function (value) {
  if (!value) return 'Não informado';
  const labels = {
    pa: 'Pronto Atendimento 24h',
    eletivo: 'Agendamento simplificado',
    ambos: 'Pronto Atendimento 24h e Agendamento simplificado',
  };
  return labels[value] || 'Não informado';
});

Vue.filter('PAYMENT_STATUS', function (value) {
  if (value === undefined || value === null) return 'Não informado';
  const normalized = value === 0 || value === '0' ? 'pending' : value.toString().toLowerCase();
  const labels = {
    paid: 'Pago',
    pending: 'Pendente',
    overdue: 'Vencido',
    failed: 'Falhou',
    cancelled: 'Cancelado',
    refunded: 'Reembolsado',
    expired: 'Expirado',
  };
  return labels[normalized] || normalized;
});

Vue.filter('PAYMENT_STATUS_VARIANT', function (value) {
  if (value === undefined || value === null) return 'secondary';
  const normalized = value === 0 || value === '0' ? 'pending' : value.toString().toLowerCase();
  const variants = {
    paid: 'success',
    pending: 'warning',
    overdue: 'danger',
    failed: 'danger',
  };
  return variants[normalized] || 'secondary';
});

Vue.config.productionTip = false;

Vue.prototype.moment = moment;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueTheMask);
Vue.use(Notifications);

Vue.component('EmailInput', EmailInput);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
